module.exports = __webpack_public_path__ + "0cd31f87e52217ccbf4b36033a369ebd.png";